/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';

export const SpanDisclaimerStyled = styled.span`
    ${({ bold }) => {
    return css`
      ${bold && 'font-weight: 400'};
    `;
  }}
`;
